import React, {useEffect, useState} from 'react';
import BaseScreen from "../base/BaseScreen";
import {
    secondaryGreenLight, primaryGreen, inter, red, Desktop, Mobile,
} from "../../Theme";
import forwardIcon from "../../resources/images/forwardWhite.svg";
import backIcon from "../../resources/images/backPink.svg"
import styled from "styled-components";
import AppStorage, {StorageKey} from "../../util/AppStorage";
import {useHistory} from "react-router-dom";
import {Loader} from "../../components/Loader";
import {useGlobalState} from "../../util/GlobalState";
import {showNativeNavigation} from "../../AppInterface";
import { showConfirmationPopup } from "../../popups/showBasicPopup";
import {
    CancelButton, CancelIcon,
    CardText, CardTitle, CardTitleWrapper,
    DesktopQuestionnaireFooter, NextStepButton, NextStepButtonIcon, NextStepButtonText, PreviousStepButton,
    PreviousStepButtonIcon, PreviousStepButtonText, QuestionDescription,
    QuestionnaireCard,
    QuestionnaireHeader,
    QuestionnaireTitle,
    QuestionnaireWrapper, QuestionsList, QuestionTitle, QuestionWrapper, StepIndicator, TabletQuestionnaireFooter
} from "./PlanOfActionQuestionnaire";
import QuestionAnswerSmileyScale from "./QuestionAnswerSmileyScale";
import QuestionAnswerTextArea from "./QuestionAnswerTextArea";
import Api from "../../util/Api";
import { isInReadOnlyMode } from "../../App";
import {UserType} from "../../constants/enums";
import { usePageDataContext } from "../../contexts/PageDataContext";
import {getContextParams, getFilterParams} from "../../util/ParamsHelpers";
import { device } from "../../constants/breakpoints";

function SelfKnowledgeQuestionnaire(props) {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [steps, setSteps] = useState([]);
    const [answers, setAnswers] = useState(null);
    const [editedAnswers, setEditedAnswers] = useState({});
    const [isNative] = useGlobalState('isNative', false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const history = useHistory();
    const [completedMode, setCompletedMode] = useState(false);
    const {selectedSchoolYear, isSchoolYearContextReady} = usePageDataContext();

    useEffect(() => {
        if (!isSchoolYearContextReady) return;

        showNativeNavigation();
        getQuestionnaire();
        // eslint-disable-next-line
    }, [selectedSchoolYear?.value, isSchoolYearContextReady]);

    const lastStep = currentStepIndex === (steps.length - 1);
    const firstStep = currentStepIndex === 0;
    const step = steps[currentStepIndex];

    const content = (
        <SelfKnowledgeQuestionnaireRoot>
            {isLoading &&
                <Loader/>
            }

            {steps.length !== 0 && answers !== null &&
                <React.Fragment>
                    <QuestionnaireWrapper>
                        <QuestionnaireHeader>
                            <QuestionnaireTitle
                                $stepType={step.type}
                                $hasDarkText
                            >
                                Breng jezelf in beeld
                            </QuestionnaireTitle>
                            <CancelButton
                                alt={"Sluiten"}
                                onClick={() => handleCloseQuestionnaire()}
                                $stepType={step.type}
                            >
                                <CancelIcon $hasDarkText />
                            </CancelButton>
                        </QuestionnaireHeader>

                        <QuestionnaireCard>
                            <CardTitleWrapper $type={step?.type ?? "text"}>
                                <CardTitle>{step.title}</CardTitle>
                            </CardTitleWrapper>

                            {step.type === "questions"
                                ?
                                <QuestionsList>
                                    {steps[currentStepIndex].questions.sort((a, b) => {
                                        return a.sortOrder - b.sortOrder
                                    }).map((question) => {
                                        const answer = answers.find(a => a.questionId === question.id);
                                        return <QuestionWrapper key={question.id}>
                                            { question.type === "smileyScale" ? (
                                                <>
                                                    <QuestionTitle>{question.title}</QuestionTitle>
                                                    {question.description && <QuestionDescription>{question.description}</QuestionDescription>}
                                                    <QuestionAnswerSmileyScale
                                                        question={question}
                                                        answer={answer}
                                                        step={step}
                                                        onPut={(oldAnswer, newAnswer) => handleNewAnswerGiven(oldAnswer, newAnswer)}
                                                        completed={completedMode}
                                                    />
                                                </>
                                            ) : (
                                                <QuestionAnswerTextArea
                                                    question={question}
                                                    answer={answer}
                                                    onPut={(oldAnswer, newAnswer) => handleNewAnswerGiven(oldAnswer, newAnswer)}
                                                    completed={completedMode}
                                                />
                                            ) }
                                        </QuestionWrapper>
                                    })}
                                </QuestionsList>
                                :
                                <CardText>
                                    {step.text}
                                </CardText>
                            }
                        </QuestionnaireCard>

                        {showError &&
                            <Desktop>
                                <QuestionnaireError>Vul alle vragen in om door te gaan naar de volgende stap.</QuestionnaireError>
                            </Desktop>
                        }
                        <DesktopFooter/>
                    </QuestionnaireWrapper>

                    {showError &&
                        <Mobile>
                            <QuestionnaireError>Vul alle vragen in om door te gaan naar de volgende stap.</QuestionnaireError>
                        </Mobile>
                    }
                    <TabletFooter/>
                </React.Fragment>
            }
        </SelfKnowledgeQuestionnaireRoot>
    );

    return (
        <BaseScreen
            activeMenuItem={"EF in beeld"}
            content={content}
        />
    )

    function handleCloseQuestionnaire() {
        if (editedAnswers[currentStepIndex]) {
            showConfirmationPopup(
                "Weet je het zeker?",
                "Weet je zeker dat je wil stoppen met het invullen van de vragenlijst? Jouw antwoorden worden niet opgeslagen tot je naar de volgende stap gaat.",
                "Vragenlijst afsluiten",
                () => history.push("/ef-voortgang"),
                "Annuleren"
            )
        } else {
            history.push("/ef-voortgang")
        }
    }

    function DesktopFooter() {
        return <DesktopQuestionnaireFooter isNative={isNative}>
            <FooterContent/>
        </DesktopQuestionnaireFooter>
    }

    function TabletFooter() {
        return <TabletQuestionnaireFooter isNative={isNative}>
            <FooterContent/>
        </TabletQuestionnaireFooter>
    }

    function FooterContent() {
        return <React.Fragment>
            <StepIndicator>Stap {currentStepIndex + 1} van {steps.length}</StepIndicator>

            <NextStepButton onClick={() => handleNextStepButtonClick(lastStep)}>
                <NextStepButtonText>{lastStep ? "Afronden" : "Volgende"}</NextStepButtonText>
                {!lastStep && <NextStepButtonIcon src={forwardIcon} alt={"Pijltje naar rechts"}/>}
            </NextStepButton>

            {!firstStep &&
                <PreviousStepButton onClick={() => handlePreviousStepButtonClick()}>
                    <PreviousStepButtonIcon src={backIcon} alt={"Pijltje naar links"}/>
                    <PreviousStepButtonText>Vorige</PreviousStepButtonText>
                </PreviousStepButton>
            }
        </React.Fragment>
    }

    function getCurrentStepAnswers() {
        let stepAnswers = [];

        steps[currentStepIndex]?.questions?.forEach((question) => {
            const answer = answers.find(a => a.questionId === question.id);
            stepAnswers.push(answer);
        });

        return stepAnswers;
    }

    function handleNextStepButtonClick(completed = false) {
        const stepAnswers = getCurrentStepAnswers();

        if (!stepAnswers.includes(undefined)) {
            if (!lastStep) {
                putData(completed);
                setShowError(false);
                setCurrentStepIndex(currentStepIndex + 1);
            } else {
                if (AppStorage.get(StorageKey.USER_TYPE) === UserType.PUPIL && !completedMode) {
                    showConfirmationPopup(
                        "Vragenlijst afronden?",
                        "Weet je zeker dat je de vragenlijst wil afronden? Na het afronden kun je deze niet meer aanpassen.",
                        "Afronden",
                        () => {
                            putData(completed, () => history.push("/ef-voortgang"));
                        },
                        "Annuleren"
                    )
                } else {
                    history.push("/ef-voortgang")
                }
            }
        } else if (completedMode && !lastStep) {
            setShowError(false);
            setCurrentStepIndex(currentStepIndex + 1);
        } else {
            setShowError(true)
        }
    }

    function putData(completed = false, onSuccess) {
        const stepAnswers = getCurrentStepAnswers()

        if (stepAnswers.length > 0 || completed) {
            const userUuid = AppStorage.get(StorageKey.USER_ID);
            const config = {
                params: getFilterParams({
                    completed,
                }),
            };

            // Put new data
            if (editedAnswers[currentStepIndex] || completed) {
                if (AppStorage.get(StorageKey.USER_TYPE) === UserType.PUPIL) {
                    Api.put("/pupils/" + userUuid + "/selfKnowledgeAnswers", stepAnswers, () => {
                        setEditedAnswers((prevState) => ({
                            ...prevState,
                            [currentStepIndex]: false
                        }));
                        onSuccess && onSuccess();
                    }, null, null, null, config);
                }
            }
        }
    }

    function handlePreviousStepButtonClick() {
        setShowError(false);

        if (!firstStep) {
            setCurrentStepIndex(currentStepIndex - 1);
        }
    }

    function getQuestionnaire() {
        const params = getContextParams();
        if (!params) return;

        const config = {
            params: {
                ...params,
            }
        }

        Api.get("/selfKnowledgeQuestionnairePages", (response) => {
            let sortedResponse = response.data.sort((a, b) => {
                return a.sortOrder - b.sortOrder
            });
            setSteps(sortedResponse);

            let edits = {}
            sortedResponse.forEach((step, index) => {
                edits[index] = false
            })
            setEditedAnswers(edits)

            const isCompleted = response.data[0]?.questionnaireCompleted ?? false;
            setCompletedMode(isCompleted || isInReadOnlyMode);

            getAnswers(sortedResponse, isCompleted);

        }, null, null, null, config);
    }

    function getAnswers(steps, isCompleted) {
        const params = getFilterParams();
        if (!params) return;

        const config = {
            params: {
                ...params
            },
        };
        Api.get("/pupils/" + AppStorage.get(StorageKey.PUPIL_ID) + "/selfKnowledgeAnswers", (response) => {
            setAnswers(response.data);
            setStepToLastUpdated(steps, response.data, isCompleted);
        }, null, null, null, config);
    }

    function handleNewAnswerGiven(oldAnswer, newAnswer) {
        setEditedAnswers((prevState) => ({
            ...prevState,
            [currentStepIndex]: true
        }));

        if (oldAnswer) {
            const oldAnswerInAnswers = answers.find(a => a.id === oldAnswer.id);
            if (oldAnswerInAnswers === undefined) {
                addNewAnswer(newAnswer)
            } else {
                replaceOldAnswerWithNewAnswer(oldAnswer, newAnswer)
            }
        } else {
            addNewAnswer(newAnswer)
        }
    }

    function addNewAnswer(newAnswer) {
        setAnswers([...answers, newAnswer])
    }

    function replaceOldAnswerWithNewAnswer(oldAnswer, newAnswer) {
        let answersCopy = [...answers];
        let oldAnswerIndex = answersCopy.findIndex(answer => {
            return answer.questionId === oldAnswer.questionId
        });
        if (oldAnswerIndex >= 0) {
            answersCopy[oldAnswerIndex] = newAnswer;
            setAnswers(answersCopy)
        } else {
            addNewAnswer(newAnswer)
        }
    }

    function setStepToLastUpdated(localSteps, localAnswers, isCompleted) {
        // If completed, start from the beginning
        if (isCompleted) return setLoading(false);

        if (!localAnswers || localAnswers.length === 0) return setLoading(false);

        let matchingAnswer = false;
        let lastMatchingStep = 0;

        localSteps.forEach((step, stepIndex) => {
            const hasAnswersInStep = step.questions?.some((question) => {
                return !!localAnswers.find(a => a.questionId === String(question.id));
            });

            if (hasAnswersInStep) {
                matchingAnswer = true;
                lastMatchingStep = stepIndex;
            }
        });

        if (matchingAnswer) {
            setCurrentStepIndex(lastMatchingStep);
        }

        setLoading(false);
    }
}

export const SelfKnowledgeQuestionnaireRoot = styled.div`
    width: 100%;
    min-height: 100%;
    position: relative;
    background: linear-gradient(${primaryGreen} 250px, ${secondaryGreenLight} 250px);
    display: flex;
    flex-direction: column;
`;

const QuestionnaireError = styled.div`
    background: white;
    padding: 0 65px 40px 65px;
    margin-top: -20px;
    font-family: ${inter};
    font-weight: 700;
    color: ${red};
    
    @media screen and ${device.tablet} {
        padding:  20px 70px 20px 30px;
    }
`;

export default SelfKnowledgeQuestionnaire;